<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`locations/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="description" class="col-md-2">Description *</label>
                  <div class="col-md-10">
                    <input
                      id="description"
                      v-model="entity.description"
                      type="text"
                      placeholder="Enter description"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="country" class="col-md-2">Country</label>
                  <div class="col-md-10">
                    <input
                      id="country"
                      v-model="entity.address.country"
                      type="text"
                      placeholder="Enter country"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="state" class="col-md-2">State</label>
                  <div class="col-md-10">
                    <input
                      id="state"
                      v-model="entity.address.state"
                      type="text"
                      placeholder="Enter state"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="city" class="col-md-2">City</label>
                  <div class="col-md-10">
                    <input
                      id="city"
                      v-model="entity.address.city"
                      type="text"
                      placeholder="Enter city"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="address" class="col-md-2">Address</label>
                  <div class="col-md-10">
                    <input
                      id="address"
                      v-model="entity.address.address"
                      type="text"
                      placeholder="Enter address"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="postal_code" class="col-md-2">Zip/Postal code</label>
                  <div class="col-md-10">
                    <input
                      id="postal_code"
                      v-model="entity.address.postal_code"
                      type="text"
                      placeholder="Enter postal code"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="organisation_name" class="col-md-2">Organisation name</label>
                  <div class="col-md-10">
                    <input
                      id="organisation_name"
                      v-model="entity.address.organisation_name"
                      type="text"
                      placeholder="Enter organisation name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="fax" class="col-md-2">Fax</label>
                  <div class="col-md-10">
                    <input
                      id="fax"
                      v-model="entity.contacts.fax"
                      type="text"
                      placeholder="Enter fax"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="email" class="col-md-2">Email</label>
                  <div class="col-md-10">
                    <input
                      id="email"
                      v-model="entity.contacts.email"
                      type="text"
                      placeholder="Enter email"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="phone" class="col-md-2">Phone</label>
                  <div class="col-md-10">
                    <input
                      id="phone"
                      v-model="entity.contacts.phone"
                      type="text"
                      placeholder="Enter phone"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="website" class="col-md-2">Website</label>
                  <div class="col-md-10">
                    <input
                      id="website"
                      v-model="entity.contacts.website"
                      type="text"
                      placeholder="Enter website"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Geocode</label>
                  <div class="col-md-5" style="margin-bottom: 1rem;">
                    <input
                      v-if="entity.geocode"
                      id="title"
                      v-model="entity.geocode.lat"
                      type="text"
                      placeholder="Enter latitude"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-5">
                    <input
                      v-if="entity.geocode"
                      id="title"
                      v-model="entity.geocode.lon"
                      type="text"
                      placeholder="Enter longitude"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-10 offset-md-2">
                    <gmap-map
                      v-if="entity.geocode"
                      style="width: 100%; height:350px; margin-top: 20px;"
                      :center="sourceMapData.center"
                      :zoom="sourceMapData.zoom"
                      @click="mapClick"
                    >
                      <gmap-marker
                        :position="entityMapCenter"
                      />
                    </gmap-map>
                  </div>
                  <div class="col-md-10 offset-md-2">
                    <button class="pull-right btn btn-primary mt-2" @click.prevent="setOldGeocode">
                      Return old geocode
                    </button>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Location has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'LocationEdit',

  components: {
    referencer: Referencer,
    terms: Terms,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [EditPageMixin, CommonPageMixin],

  computed: {
    sourceMapData() {
      if (!this.source.geocode || this.source.geocode.lat == null || this.source.geocode.lon == null) {
        return {
          center: {
            lat: 0,
            lng: 0,
          },
          zoom: 2,
        };
      }
      return {
        center: {
          lat: _.toNumber(this.source.geocode.lat),
          lng: _.toNumber(this.source.geocode.lon),
        },
        zoom: 13,
      };
    },
    entityMapCenter() {
      if (this.entity.geocode === undefined || this.entity.geocode.lat == null || this.entity.geocode.lon == null) {
        return {
          lat: 0,
          lng: 0,
        };
      }
      return {
        lat: _.toNumber(this.entity.geocode.lat),
        lng: _.toNumber(this.entity.geocode.lon),
      };
    },
  },
  methods: {
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
        { name: 'Description', value: this.entity.description, type: 'required' },
        { name: 'Email', value: this.entity.contacts.email, type: 'email' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}locations/${this.$route.params.id}`, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured'],
        },
      }).then((response) => {
        this.source = this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'contacts') || !response.data.contacts) {
          this.source.contacts = {};
        }
        this.entity = _.cloneDeep(this.source);
        if (response.data.geocode === null) {
          this.entity.geocode = { lat: null, lon: null };
        }
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting location request' });
        console.error(error);
      });
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      const { entity } = this;
      postFormData.append('title', entity.title);
      postFormData.append('description', entity.description ? entity.description : '');
      postFormData.append('country', entity.address.country ? entity.address.country : '');
      postFormData.append('state', entity.address.state ? entity.address.state : '');
      postFormData.append('city', entity.address.city ? entity.address.city : '');
      postFormData.append('address', entity.address.address ? entity.address.address : '');
      postFormData.append('postal_code', entity.address.postal_code ? entity.address.postal_code : '');
      postFormData.append(
        'organisation_name',
        entity.address.organisation_name ? entity.address.organisation_name : '',
      );
      postFormData.append('fax', entity.contacts.fax ? entity.contacts.fax : '');
      postFormData.append('email', entity.contacts.email ? entity.contacts.email : '');
      postFormData.append('phone', entity.contacts.phone ? entity.contacts.phone : '');
      postFormData.append('website', entity.contacts.website ? entity.contacts.website : '');
      postFormData.append('lat', entity.geocode.lat ? entity.geocode.lat : '');
      postFormData.append('lon', entity.geocode.lon ? entity.geocode.lon : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}locations/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.$_successSave();
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in update location query', error);
      });
    },
    mapClick(event) {
      this.entity.geocode.lat = event.latLng.lat();
      this.entity.geocode.lon = event.latLng.lng();
    },
    setOldGeocode() {
      this.entity.geocode.lat = this.source.geocode.lat;
      this.entity.geocode.lon = this.source.geocode.lon;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?5d8918f1